import React from "react";
import "../style.scss";

interface IProps {
  percentageFree: number;
}

const DotsDisplay: React.FC<IProps> = ({ percentageFree }) => {
  const getDotCount = (percentage: number): number => {
    if (percentage < 20) return 1;
    else if (percentage >= 20 && percentage < 60) return 2;
    else return 3;
  };

  const dotCount = getDotCount(percentageFree);

  const getDotColor = (dotCount: number) => {
    if (dotCount > 2) {
      return "green";
    } else if (dotCount === 2) {
      return "orange";
    } else {
      return "red";
    }
  };

  return (
    <div className={`dots-display dots-${dotCount}`}>
      {Array.from({ length: dotCount }, (_, index) => (
        <div key={index} className={`dot dot-${getDotColor(dotCount)}`}></div>
      ))}
      {Array.from({ length: 3 - dotCount }, (_, index) => (
        <div key={index} className="dot dot-gray"></div>
      ))}
    </div>
  );
};

export default DotsDisplay;
